export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Properly transparent PNG variants generated locally (see /public/logos/).
// LOGO_LIGHT = black text on transparent bg (use on light/cream surfaces)
// LOGO_DARK  = white text on transparent bg (use on dark surfaces)
export const LOGO_LIGHT = "/logos/ladiosas-black.png";
export const LOGO_DARK = "/logos/ladiosas-white.png";
export const LOGO_URL = LOGO_LIGHT;

export const SOCIAL = {
  instagram: {
    handle: "@ladiosas.co",
    url: "https://instagram.com/ladiosas.co",
  },
  facebook: {
    handle: "Ladiosas.co",
    url: "https://www.facebook.com/ladiosas.co/",
  },
};

export const HERO_IMAGES = {
  brasserie:
    "https://images.unsplash.com/photo-1768051297578-1ea70392c307?auto=format&fit=crop&w=2000&q=80",
  interior:
    "https://images.unsplash.com/photo-1747331185192-5a5bbb429cfb?auto=format&fit=crop&w=2000&q=80",
  signature:
    "https://images.unsplash.com/photo-1598679253544-2c97992403ea?auto=format&fit=crop&w=1600&q=80",
  brunch:
    "https://images.unsplash.com/photo-1623073284793-84dc366d4798?auto=format&fit=crop&w=1600&q=80",
  // Editorial sliders / champagne service / truffle fries — brand-neutral
  sliders_main:
    "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=1600&q=80",
  champagne_pour:
    "https://images.unsplash.com/photo-1551024709-8f23befc6f87?auto=format&fit=crop&w=1200&q=80",
  fries_truffle:
    "https://images.unsplash.com/photo-1541592106381-b31e9677c0e5?auto=format&fit=crop&w=1200&q=80",
};

export const GALLERY = [
  // Editorial brasserie / mediterranean / soul food photography
  "https://images.unsplash.com/photo-1672636402078-4b957a572e4e?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1672636401225-ec3d4025a4af?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1567611737631-4b922e6c2497?auto=format&fit=crop&w=1200&q=80",
  "https://images.pexels.com/photos/9872916/pexels-photo-9872916.jpeg?auto=compress&w=1200",
  "https://images.unsplash.com/photo-1623073284793-84dc366d4798?auto=format&fit=crop&w=1200&q=80",
  "https://images.pexels.com/photos/12118977/pexels-photo-12118977.jpeg?auto=compress&w=1200",
  "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1559339352-11d035aa65de?auto=format&fit=crop&w=1200&q=80",
];

export const CONTACT_INFO = {
  street: "1407 Westheimer Rd",
  cityState: "Houston, Texas 77006",
  phone: "(713) 555-0142",
  email: "hello@ladiosas.co",
  hours: [
    { day: "Mon – Wed", time: "11:30 — 22:00" },
    { day: "Thu – Sat", time: "11:00 — 23:30" },
    { day: "Sunday", time: "10:00 — 21:00  (Brunch)" },
  ],
  ig: "@ladiosas.co",
  ig_url: "https://instagram.com/ladiosas.co",
  fb: "Ladiosas.co",
  fb_url: "https://www.facebook.com/ladiosas.co/",
};
